export default "__VITE_ASSET__a8206f4b__"